import React from "react";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { ScreenWatcher } from "@common/screenWatcher";
import { LayoutWatcher } from "@common/layoutWatcher";
import { MilestoneIcon } from "@common/milestoneIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function hashCode(str: string) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
}

function generateRandomColor(name: string) {
  return `#${intToRGB(hashCode(name))}`;
}

function Milestone({ milestone }: Props) {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const { pushView } = useModal();
  const backgroundColor = generateRandomColor(milestone.project.name);

  return (
    <ScreenWatcher
      renderChildren={() => (
        <LayoutWatcher
          renderChildren={({ height: h, width: w }) => {
            const rect = ref.current && ref.current.getBoundingClientRect();
            const width = rect ? rect.width : w;
            const height = rect ? rect.height : h;

            return (
              <div
                ref={ref}
                className={styles.milestone}
                onClick={() =>
                  pushView({
                    data: { milestone, isMultiProject: true },
                    key: UseCases.retrieveMilestone,
                  })
                }
              >
                <div className={styles.main}>
                  <MilestoneIcon
                    milestone={milestone}
                    className={styles.icon}
                    style={{ fill: backgroundColor }}
                  />
                  <p className={styles.name}>{milestone.name}</p>
                </div>
              </div>
            );
          }}
        />
      )}
    />
  );
}

export { Milestone };
